import ScrollReveal from '@/components/feature/ScrollReveal';

const checklist = [
  'International Holidays',
  'Domestic Tours',
  'Honeymoon Packages',
  'Family Holidays',
  'Group Tours',
  'Corporate Travel',
  'Flights',
  'Hotels',
  'Visa Services',
  'Cruise Holidays',
  'Customized Itineraries',
];

const WHATSAPP_URL = 'https://wa.me/919003560700?text=Hello%20Lucky%20Holidays%2C%0A%0AI%20would%20like%20to%20know%20more%20about%20your%20travel%20services%20and%20customized%20holiday%20packages.%0A%0APlease%20assist%20me%20with%20planning%20my%20dream%20holiday.%0A%0AThank%20You.';

export default function CTABannerSection() {
  const actionSchema = {
    '@context': 'https://schema.org',
    '@type': 'TravelAction',
    name: 'Plan Your Dream Holiday with Lucky Holidays',
    description: 'Contact Lucky Holidays travel experts to plan your perfect international or domestic holiday with customized packages, flights, hotels, and visa assistance.',
    agent: {
      '@type': 'TravelAgency',
      name: 'Lucky Holidays India Private Limited',
      url: 'https://www.luckyholidays.in/',
      telephone: '+91-90035-60700',
    },
  };

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <script type="application/ld+json">{JSON.stringify(actionSchema)}</script>
      <div className="absolute inset-0">
        <img
          alt="Plan your dream holiday with Lucky Holidays travel agency in Hosur Tamil Nadu India"
          title="Lucky Holidays - Plan Your Dream Holiday Today"
          className="w-full h-full object-cover object-top"
          src="https://readdy.ai/api/search-image?query=Elegant%20travel%20planning%20desk%20with%20world%20map%2C%20premium%20leather%20notebook%2C%20compass%2C%20and%20coffee%2C%20luxury%20travel%20lifestyle%2C%20warm%20golden%20lighting%2C%20sophisticated%20office%20setting%2C%20minimalist%20composition%2C%20professional%20aesthetic&width=1600&height=800&seq=lucky-cta-bg&orientation=landscape"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-primary-800/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 3xl:max-w-[1800px] 3xl:mx-auto tv:max-w-[3000px] tv:mx-auto">
        <ScrollReveal direction="up" className="max-w-3xl tv:max-w-4xl">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl 3xl:text-6xl font-bold text-background-50 mb-4">
            Plan Your Dream Holiday Today
          </h2>
          <p className="text-background-100/80 text-sm md:text-base mb-8 max-w-xl">
            Need help choosing your perfect destination? Our travel experts at Lucky Holidays will guide you through every option to find the ideal journey for you. We offer flights, hotels, visa assistance, and customized packages.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
            {checklist.map((item, idx) => (
              <ScrollReveal key={item} delay={idx * 40} direction="up" distance={15}>
                <div className="flex items-center gap-2 text-background-50/90 group cursor-default">
                  <i className="ri-check-line text-accent-400 text-sm group-hover-icon-bounce"></i>
                  <span className="text-xs md:text-sm whitespace-nowrap">{item}</span>
                </div>
              </ScrollReveal>
            ))}
          </div>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ripple inline-flex items-center px-8 py-3.5 bg-accent-500 text-background-50 font-semibold text-sm rounded-full hover:bg-accent-600 hover-glow-accent transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line mr-2 text-lg group-hover-icon-bounce"></i>Talk To Our Travel Expert
          </a>
        </ScrollReveal>
      </div>
    </section>
  );
}